import { useEffect, useRef } from "react";

export const useNotificationSound = (enabled: boolean): () => void => {
  const audioRef = useRef<HTMLAudioElement | null>(null);
  const enabledRef = useRef<boolean>(enabled);

  // keep the latest enabled value
  useEffect(() => {
    enabledRef.current = enabled;
  }, [enabled]);

  // initialize audio once
  useEffect(() => {
    audioRef.current = new Audio("/sounds/notification.mp3");
    audioRef.current.volume = 0.8;
  }, []);

  // no useCallback — always uses latest refs
  const playSound = (): void => {
    // console.log("🔈 playSound: enabled =", enabledRef.current);
    if (enabledRef.current && audioRef.current) {
      audioRef.current.play().catch(() => {});
    }
  };

  return playSound;
};